const en = {
  nav: {
    home: 'HOME',
    about: 'ABOUT',
    experience: 'EXPERIENCE',
    work: 'WORK',
  },
  hero: {
    greeting: "Hello, I'm",
    role: 'Fullstack Developer 💻',
    description: 'Building web apps, mobile apps, and backend systems since 2021.',
    cta: 'VIEW MY WORK',
    github: 'GITHUB →',
    techStack: 'Tech stack',
  },
  about: {
    sectionLabel: 'About',
    title: 'About Me',
    headline1: 'I turn ideas into',
    headline2: 'real products.',
    bio: "Since 2021 I've worked across the full stack — developing web platforms, maintaining production systems, building mobile apps, and connecting services through APIs and microservices. My main tools are React, Node.js, and SQL, with cloud experience on AWS. I've delivered projects end-to-end for real clients, always looking for the right solution rather than the fast one. I love a good challenge and I'm always learning something new.",
    stats: [
      { value: '4+',   label: 'Years of experience' },
      { value: '10+',  label: 'Projects delivered'  },
      { value: '100%', label: 'Self-taught'          },
    ],
    cvButton: 'View My CV',
    techLabel: 'Technologies',
    techTitle: 'My tech stack',
    categories: {
      frontend: 'Frontend',
      backend: 'Backend',
      mobile: 'Mobile',
      tools: 'Tools',
    },
    cvModal: {
      title: 'Curriculum Vitae',
      download: 'Download',
      loading: 'Loading PDF…',
      error: 'Could not load PDF preview',
      downloadInstead: 'Download CV instead',
      prev: 'Prev',
      next: 'Next',
      of: 'of',
    },
  },
  work: {
    sectionLabel: 'Career',
    title: 'Experience',
    responsibilities: 'Responsibilities',
    techStack: 'Tech Stack',
    expand: 'Expand',
    collapse: 'Collapse',
    experience: [
      {
        date: '2022 – Present',
        badge: 'Current',
        title: 'Fullstack Developer',
        company: 'IDC Online',
        companyUrl: 'https://idconline.mx/',
        description:
          'Web development, API maintenance, web platforms, backend systems and mobile app development in React Native. Published on both stores. ERP and CRM integrations.',
        activities: [
          'Development and publication of the mobile app on App Store & Google Play.',
          'Maintenance of existing APIs and creation of new services.',
          'Maintenance and development on AWS.',
          'SQL database management.',
          'Web development and deployment.',
          'Data usage and Odoo development.',
          'Creation and use of data and backend services.',
          'Testing and debugging.',
        ],
        tags: ['REACT_NATIVE', 'NODE', 'AWS', 'SQL', 'ODOO', 'TYPESCRIPT', 'JAVASCRIPT', 'SQL', 'EXPO'],
      },
      {
        date: '2021',
        badge: null,
        title: 'Frontend Developer',
        company: '4Plus1 Creative',
        companyUrl: 'https://4plus1creative.com/',
        description:
          'Web pages and systems with JavaScript, API integrations, and backend maintenance.',
        activities: [
          'Web site design and implementation.',
          'Maintenance of backend systems.',
          'Database management.',
        ],
        tags: ['JAVASCRIPT', 'HTML', 'CSS', 'NODE', 'GOLANG'],
      },
      {
        date: '2020',
        badge: 'First job',
        title: 'Mobile Developer',
        company: 'Marzhal Hackers',
        companyUrl: 'https://www.instagram.com/marzhalhackers/',
        description:
          'Built a React Native mobile app and a web platform as an internship project.',
        activities: [
          'Development of the mobile application in React Native.',
          'Creation of a web platform.',
          'Testing and debugging.',
        ],
        tags: ['REACT_NATIVE', 'JAVASCRIPT'],
      },
    ],
  },
  projects: {
    sectionLabel: 'RECENT WORK',
    subtitle: "A selection of projects I've built. Click any card to see more.",
    viewProject: 'View project',
    clickToView: 'Click to view →',
    availableOn: 'Available on',
    stack: 'Stack',
    clickToExpand: 'Click to expand',
    close: 'Close',
    status: {
      inProgress: 'In Progress',
      published:  'Published',
      completed:  'Completed',
    },
    items: [
      {
        title: 'Task Management App',
        shortDesc: 'Multi-platform to-do app with real-time sync.',
        description:
          'A cross-platform to-do application with real-time synchronization between the mobile app and the web dashboard. Built from scratch with a Node.js REST API and deployed on AWS. Features include authentication, task categories, reminders, and offline support.',
        statusKey: 'inProgress',
      },
      {
        title: 'IDC Mobile App',
        shortDesc: 'Mobile app for IDC Online customers.',
        description:
          'First professional project — a full-featured mobile application for IDC Online customers. Developed from scratch using React Native with Expo. Published on both the Apple App Store and Google Play Store. Includes real-time content, push notifications, and a clean design system.',
        statusKey: 'published',
      },
      {
        title: 'Loan Management System',
        shortDesc: 'Fully functional and automated in all its tasks.',
        description:
          'A fully automated system for managing and administering customer loans, controlled via an API to process payments, penalties, and other transactions. Responsive across all devices, with user management and role management. Developed for a private client.',
        statusKey: 'completed',
      },
    ],
  },
  footer: {
    about: 'About',
    privacy: 'Privacy Policy',
    contact: 'Contact',
    madeBy: 'Made with 💗 by me.',
  },
}

export default en
